import { ConfigHeader } from "../../types/config";
import {
  facebookIcon,
  instagramIcon,
  telegramIcon,
  youtubeIcon,
} from "../icons/socialIcon";

export const configHeader: ConfigHeader = {
  megaMenu: {
    newsletter: {
      text: "Parents, let's stay sane together. Sign up for our weekly newsletters for the latest deals, tips, and feel-good reads.",
      url: "/newsletter-signup",
      buttonText: "SIGN UP",
    },
    closeButton: {
      type: "icon",
      placement: "right",
    },
  },
  socialMedia: {
    target: "_blank",
    icons: [
      {
        icon: telegramIcon,
        name: "Telegram",
        href: "https://t.me/sgwomensweekly",
      },
      {
        icon: instagramIcon,
        name: "Instagram",
        href: "https://www.instagram.com/thesingaporewomensweekly/",
      },
      {
        icon: facebookIcon,
        name: "Facebook",
        href: "https://www.facebook.com/thesingaporewomensweekly",
      },

      {
        icon: youtubeIcon,
        name: "Youtube",
        href: "https://www.youtube.com/channel/UCzrU7b6Kk7W3k5PIQAGDwKA",
      },
    ],
  },
};

export const svgSearchIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="#F9F9FB"
      d="m27.91 26.49-6.28-6.28c1.42-1.73 2.28-3.95 2.28-6.36 0-5.54-4.51-10.05-10.05-10.05C8.32 3.8 3.8 8.31 3.8 13.85c0 5.54 4.51 10.05 10.05 10.05 2.41 0 4.63-.86 6.36-2.28l6.28 6.28c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41ZM5.8 13.85c0-4.44 3.61-8.05 8.05-8.05 4.44 0 8.05 3.61 8.05 8.05 0 4.44-3.61 8.05-8.05 8.05-4.44 0-8.05-3.61-8.05-8.05Z"
    />
  </svg>
);

export const svgHamburgerMenu = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="#F9F9FB"
      d="M26 10.6H6c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1ZM26 17H6c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1ZM26 23.4H6c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1Z"
    />
  </svg>
);
